// extracted by mini-css-extract-plugin
export default {"button":"E0JwU","wrapper":"_4mY7A","label":"q68rX","bubble":"k-qdE"};